import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { Container, Content, Form } from './styles'
import { Breakpoint } from '@mui/material/styles'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'
import { cnpjCpfMask, foneMask } from '../../../utils/masks'
import { validateCnpjCpf } from '../../../utils/validate'
import { Autocomplete, MenuItem, Select, TextField } from '@mui/material'
import validator from 'validator'
import toast from 'react-hot-toast'
import { useBancos } from '../../../hooks/bancos'
import { useContacts } from '../../../hooks/contacts'
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />
})
interface AlertDialogDeleteProps {
    isSaveOrEditOpen: boolean
    setIsSaveOrEditOpen: (valor: boolean) => void
    setContacts: (contact: any) => void
    contacts: any[]
    cnpj_cpf: string
    title: string
    width?: Breakpoint | false | undefined
    contact: any
}

interface Inputs {
    agencia: string
    compe: string
    email: string
    ispb: string
    nomeTitular: string
    numeroConta: string
    numeroDocumentoTitular: string
    telefone: string
    tipoConta: string
}

function SaveOrEdit({
    isSaveOrEditOpen,
    setIsSaveOrEditOpen,
    cnpj_cpf,
    contact,
    contacts,
    setContacts,
    title,
}: AlertDialogDeleteProps) {
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        getValues,
    } = useForm<Inputs>()
    const { saveContact } = useContacts()
    const { bancos, getIspb } = useBancos()
    const [numeroConta, setNumeroConta] = useState('')
    const [valueBanco, setValueBanco] = useState(['', ''])

    useEffect(() => {
        if (isSaveOrEditOpen) {
            reset(contact)
            setNumeroConta(contact.numeroConta)
            const compe = contact.compe
            const banco = bancos[compe]
            setValueBanco([compe, banco])
        }
    }, [reset, contact, isSaveOrEditOpen, bancos])

    if (!isSaveOrEditOpen) {
        return null
    }

    const submit: SubmitHandler<Inputs> = async (inputs) => {
        try {
            const values = getValues()
            const contratoData = {
                ...values,
                numeroConta: numeroConta,
                numeroDocumentoTitular: values.numeroDocumentoTitular.replace(
                    /\D/g,
                    ''
                ),
                telefone: values.telefone.replace(/\D/g, ''),
                ispb: getIspb(values.compe),
            }
            const data = await saveContact({
                ...contratoData,
                cnpj_cpf,
                contactId: contact?.id || undefined,
            })
            // const { data } = await api.post('/contato', {
            //   ...contratoData,
            //   cnpj_cpf,
            //   contactId: contact?.id || undefined
            // })
            if (contact?.id) {
                const newContacts = contacts.map((existingContact: any) => {
                    if (existingContact.id === contact.id) {
                        return data
                    }
                    return existingContact
                })
                setContacts(newContacts)
            } else {
                const newContacts = [...contacts]
                newContacts.unshift(data)
                setContacts(newContacts)
            }
            setIsSaveOrEditOpen(false)
        } catch (error) {
            toast.error('Desculpe, não foi possível salvar este contato')
        }
    }

    function handleClose() {
        setIsSaveOrEditOpen(false)
        reset()
    }
    function handleChange(
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        // if(e.target.name === 'numeroDocumentoTitular') {
        //     e.target.maxLength = 18
        //     e.target.value = cnpjCpfMask(e.target.value)
        // }
        if (e.target.name === 'numeroConta') {
            let value = e.target.value
            value = value.replace(/\D/g, '')
            const array = value.split('')
            const ultimoDigito = array.pop()
            const contaSemDigito = array.join('')
            let conta = ultimoDigito
            if (array.length >= 1) {
                conta = `${contaSemDigito}-${ultimoDigito}`
            }
            e.target.value = conta || ''
            setNumeroConta(e.target.value)
        }
    }

    return (
        <div>
            <Dialog
                open={isSaveOrEditOpen}
                TransitionComponent={Transition}
                keepMounted
                maxWidth="md"
                fullWidth
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <Container>
                        <Content>
                            <Form
                                id="form-save-edit"
                                onSubmit={handleSubmit(submit)}
                            >
                                {/* <legend>Dados do recebedor</legend> */}
                                <div className="input-group">
                                    <div className="input-wrapper">
                                        <Controller
                                            defaultValue=""
                                            name="nomeTitular"
                                            control={control}
                                            rules={{
                                                required:
                                                    'O campo nome do titular é obrigatório',
                                                minLength: 3,
                                                maxLength: 100,
                                            }}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="input"
                                                    id="nomeTitular"
                                                    placeholder="Nome do titular"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                        {errors.nomeTitular &&
                                            errors.nomeTitular.type ===
                                                'required' && (
                                                <span className="hook-error">
                                                    {errors.nomeTitular.message}
                                                </span>
                                            )}
                                        {errors.nomeTitular &&
                                            errors.nomeTitular.type ===
                                                'minLength' && (
                                                <span className="hook-error">
                                                    O campo nome do titular deve
                                                    ter pelo menos 3 caracteres
                                                </span>
                                            )}
                                        {errors.nomeTitular &&
                                            errors.nomeTitular.type ===
                                                'maxLength' && (
                                                <span className="hook-error">
                                                    O campo nome do titular deve
                                                    ter no máximo 100 caracteres
                                                </span>
                                            )}
                                    </div>
                                </div>

                                <div className="input-group">
                                    <div className="input-wrapper">
                                        <Controller
                                            defaultValue=""
                                            name="numeroDocumentoTitular"
                                            control={control}
                                            rules={{
                                                required:
                                                    'O campo Cnpj ou Cpf é obrigatório',
                                                validate: (value: string) =>
                                                    validateCnpjCpf(value),
                                            }}
                                            render={({
                                                field: { value, ...field },
                                            }) => (
                                                <TextField
                                                    {...field}
                                                    value={cnpjCpfMask(
                                                        value || ''
                                                    )}
                                                    className="input"
                                                    id="numeroDocumentoTitular"
                                                    placeholder="CPF/CNPJ"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                        {errors.numeroDocumentoTitular &&
                                            errors.numeroDocumentoTitular
                                                .type === 'required' && (
                                                <span className="hook-error">
                                                    {
                                                        errors
                                                            .numeroDocumentoTitular
                                                            .message
                                                    }
                                                </span>
                                            )}
                                        {errors.numeroDocumentoTitular &&
                                            errors.numeroDocumentoTitular
                                                .type === 'validate' && (
                                                <span className="hook-error">
                                                    Cnpj ou Cpf inválido
                                                </span>
                                            )}
                                        {/* {errors.numeroDocumentoTitular && errors.numeroDocumentoTitular.type === 'maxLength' && (<span className='hook-error'>O campo Cnpj ou Cpf deve ter no máximo 18 caracteres</span>)} */}
                                    </div>
                                    <div className="input-wrapper">
                                        <Controller
                                            defaultValue=""
                                            name="compe"
                                            control={control}
                                            render={({ field }) => (
                                                <Autocomplete
                                                    onChange={(
                                                        event,
                                                        newValue
                                                    ) => {
                                                        const value: string =
                                                            newValue
                                                                ? newValue[0]
                                                                : ''
                                                        setValueBanco(
                                                            newValue || ['', '']
                                                        )
                                                        field.onChange(value)
                                                    }}
                                                    // onInputChange={(event, value) => {
                                                    //     // const { data } = await api.get(`/comissao/taxa/${cnpj_cpf}`)
                                                    //     // if(value === '') setSelectedFav({})
                                                    //     const compe = value.split('-')[0].trim()
                                                    //     field.onChange(compe)
                                                    // }}
                                                    getOptionLabel={(
                                                        option
                                                    ) => {
                                                        return option[1]
                                                    }}
                                                    isOptionEqualToValue={(
                                                        option,
                                                        value
                                                    ) => {
                                                        return (
                                                            option[0] ===
                                                            value[0]
                                                        )
                                                    }}
                                                    disablePortal
                                                    value={valueBanco}
                                                    id="compe"
                                                    options={Object.entries(
                                                        bancos
                                                    )}
                                                    sx={{
                                                        width: '100%',
                                                        fontFamily: 'Roboto',
                                                        fontSize: '18px',
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label=""
                                                            placeholder="Banco"
                                                        />
                                                    )}
                                                />
                                            )}
                                        />
                                        {errors.compe &&
                                            errors.compe.type ===
                                                'required' && (
                                                <span className="hook-error">
                                                    {errors.compe.message}
                                                </span>
                                            )}
                                    </div>
                                </div>

                                <div className="input-group tripple">
                                    <div className="input-wrapper">
                                        <Controller
                                            defaultValue=""
                                            name="agencia"
                                            control={control}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="input"
                                                    id="agencia"
                                                    placeholder="Agência"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                        {errors.agencia &&
                                            errors.agencia.type ===
                                                'required' && (
                                                <span className="hook-error">
                                                    {errors.agencia.message}
                                                </span>
                                            )}
                                        {errors.agencia &&
                                            errors.agencia.type ===
                                                'minLength' && (
                                                <span className="hook-error">
                                                    O campo agência deve ter
                                                    pelo menos 2 caracteres
                                                </span>
                                            )}
                                        {errors.agencia &&
                                            errors.agencia.type ===
                                                'maxLength' && (
                                                <span className="hook-error">
                                                    O campo agência deve ter no
                                                    máximo 10 caracteres
                                                </span>
                                            )}
                                    </div>
                                    <div className="input-wrapper">
                                        <Controller
                                            defaultValue=""
                                            name="numeroConta"
                                            control={control}
                                            rules={{
                                                required: false,
                                                onChange: (e) =>
                                                    handleChange(e),
                                            }}
                                            render={({
                                                field: { value, ...field },
                                            }) => (
                                                <TextField
                                                    {...field}
                                                    value={numeroConta}
                                                    onChange={(e) =>
                                                        field.onChange(e)
                                                    }
                                                    className="input"
                                                    id="numeroConta"
                                                    placeholder="Número da conta"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                        {errors.numeroConta &&
                                            errors.numeroConta.type ===
                                                'required' && (
                                                <span className="hook-error">
                                                    {errors.numeroConta.message}
                                                </span>
                                            )}
                                    </div>
                                    <div className="input-wrapper">
                                        <Controller
                                            defaultValue="null"
                                            name="tipoConta"
                                            control={control}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    sx={{ width: '100%' }}
                                                    labelId="tipoConta-label"
                                                    id="tipoConta-select"
                                                    placeholder="Tipo de conta"
                                                >
                                                    <MenuItem
                                                        disabled
                                                        value="null"
                                                    >
                                                        Selecionar tipo de conta
                                                    </MenuItem>
                                                    <MenuItem value="CC">
                                                        CC - Conta Corrente
                                                    </MenuItem>
                                                    <MenuItem value="PP">
                                                        PP - Conta Poupança
                                                    </MenuItem>
                                                </Select>
                                            )}
                                        />
                                        {errors.tipoConta &&
                                            errors.tipoConta.type ===
                                                'validate' && (
                                                <span className="hook-error">
                                                    Selecione o tipo da conta
                                                </span>
                                            )}
                                    </div>
                                </div>
                                <div className="input-group">
                                    <div className="input-wrapper">
                                        <Controller
                                            defaultValue=""
                                            name="email"
                                            control={control}
                                            rules={{
                                                required:
                                                    'O campo email é obrigatório',
                                                validate: (email: string) =>
                                                    validator.isEmail(email),
                                            }}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    className="input"
                                                    id="email"
                                                    placeholder="Email"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                        {errors.email &&
                                            errors.email.type ===
                                                'required' && (
                                                <span className="hook-error">
                                                    {errors.email.message}
                                                </span>
                                            )}
                                        {errors.email &&
                                            errors.email.type ===
                                                'validate' && (
                                                <span className="hook-error">
                                                    Digite um email válido
                                                </span>
                                            )}
                                    </div>
                                    <div className="input-wrapper">
                                        <Controller
                                            defaultValue=""
                                            name="telefone"
                                            control={control}
                                            render={({
                                                field: { value, ...field },
                                            }) => (
                                                <TextField
                                                    {...field}
                                                    value={foneMask(
                                                        value || ''
                                                    )}
                                                    className="input"
                                                    id="telefone"
                                                    placeholder="Telefone"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </div>
                                </div>

                                <div className="input-group">
                                    <div className="input-wrapper">
                                        {/* <textarea defaultValue='' {...register('observacao')} className='text-area' name="observacao" id="" placeholder='Digite um observação ou descrição sobre o contrato'></textarea> */}
                                    </div>
                                </div>
                            </Form>
                        </Content>
                    </Container>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button type="submit" form="form-save-edit">
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default SaveOrEdit
